import { ConfirmDialog } from "@tellescope/ui";
import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { formatName } from "@tellescope/utils";
import { useTranslation } from "react-i18next";

export interface UnavailableUsersWarningDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  unavailableUsers: TellescopeModelFromName<"users">[];
}

export const UnavailableUsersWarningDialog = ({
  open,
  onOpenChange,
  onConfirm,
  unavailableUsers,
}: UnavailableUsersWarningDialogProps) => {
  const { t } = useTranslation("calendar");

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      variant="warning"
      title={unavailableUsers.length > 1 ? t("Users Unavailable") : t("User Unavailable")}
      description={t("At least one of the users selected isn't available during the selected time")}
      confirmText={t("Continue anyway")}
      cancelText={t("Cancel")}
      onConfirm={onConfirm}
      confirmButtonTestId="unavailable-users-warning-confirm"
    >
      <ul className="list-disc pl-4 space-y-1">
        {unavailableUsers.map((user) => (
          <li key={user.id} className="text-sm">
            {formatName(user) || t("User: {{id}}", { id: user.id })}
          </li>
        ))}
      </ul>
    </ConfirmDialog>
  );
};
